import { Box, Typography } from '@material-ui/core';
import OrderMgmtStyles from '../../../OrderManagement.style';

export const OrderMgmtDisclaimer = ({ title, description }: Props) => {
  const componentClasses = OrderMgmtStyles();

  return (
    <Box
      className={componentClasses.disclaimerContent}
      display='flex'
      flexDirection='column'
      width='100%'
    >
      {title && (
        <Typography
          className={componentClasses.disclaimerTitle}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      <Box display='flex' alignItems='center'>
        <Typography
          className={componentClasses.disclaimerDescription}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </Box>
    </Box>
  );
};

interface Props {
  title?: string;
  description: string;
}
